<input (ngModelChange)='inputChanged($event)' [ngModel]='displayedCode' pInputText placeholder='Partner ID' type='text' style="text-transform: lowercase;">
